import { i18nMark } from 'lingui-react';

const messages = {
  jumpTo: i18nMark('Jump To...'),
  ASSET_FAULT_DIAGNOSTIC_WIDGET: i18nMark('Diagnostics'),
  ASSET_LOCATION_WIDGET: i18nMark('Location'),
  ASSET_SUMMARY_WIDGET: i18nMark('Asset Summary'),
  CASE_ASSETS_WIDGET: i18nMark('Asset'),
  CASE_COMPLAINT_WIDGET: i18nMark('Complaint'),
  CASE_FAULT_DIAGNOSTIC_WIDGET: i18nMark('Diagnostics'),
  CASE_LOCATION_WIDGET: i18nMark('Location'),
  CASE_NOTES_WIDGET: i18nMark('Notes'),
  CASE_SERVICE_PROVIDER_WIDGET: i18nMark('Service Provider'),
  CASE_SERVICE_REQUEST_INFO_WIDGET: i18nMark('Service Request'),
  CASE_STATUS_WIDGET: i18nMark('Case Status'),
  ESTIMATE_INVOICE_DECIDED_WIDGET: i18nMark('Estimate Invoice'),
  ESTIMATE_INVOICE_PENDING_WIDGET: i18nMark('Estimate Invoice'),
  QR_CODE_WIDGET: i18nMark('QR Code'),
  OPEN_EVENTS_WIDGET: i18nMark('Open Events'),
  SERVICE_REQUEST_ASSETS_WIDGET: i18nMark('Asset'),
  SERVICE_REQUEST_COMPLAINT_WIDGET: i18nMark('Complaint'),
  SERVICE_REQUEST_LOCATION_WIDGET: i18nMark('Location'),
  SERVICE_REQUEST_NOTES_WIDGET: i18nMark('Notes'),
  SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET: i18nMark('Service Provider'),
  SERVICE_REQUEST_SERV_REQ_INFO_WIDGET: i18nMark('Service Request'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/JumpToButton/messages.js